import React from "react";
import { Container } from "semantic-ui-react";
import BasicPageLayout from "../../../components/layouts/BasicPageLayout";

interface SalesReportLayoutProps {
    children?: React.ReactNode;
}

export const SalesReportLayout: React.FC<SalesReportLayoutProps> = (props) => {
    return (
        <BasicPageLayout>
            <div style={{ height: "100%", overflow: "auto" }}>
                <Container>{props.children}</Container>
            </div>
        </BasicPageLayout>
    );
};
